module.exports = __webpack_public_path__ + "media/images/store_badges/app_store/app_store_it-7a446ca6a66b26e455537d49b4cdcc76.png";